
import { ChatInput } from "@/components/chat/ChatInput";

interface ChatInputAreaProps {
  onSendMessage: (message: string) => void;
  isLoading: boolean;
  isConnected: boolean;
  onToggleSidebar?: () => void;
  onEmailSend?: (emailData: any) => void;
}

export function ChatInputArea({ 
  onSendMessage, 
  isLoading, 
  isConnected,
  onToggleSidebar,
  onEmailSend 
}: ChatInputAreaProps) {
  return (
    <div className="shrink-0 border-t border-border/50 bg-background/80 backdrop-blur-sm">
      <div className="p-4">
        <ChatInput 
          onSendMessage={onSendMessage} 
          isLoading={isLoading}
          disabled={!isConnected}
          onToggleSidebar={onToggleSidebar}
          onEmailSend={onEmailSend}
        />
        {!isConnected && (
          <p className="text-xs text-muted-foreground text-center mt-2">
            Waiting for connection to be established...
          </p>
        )}
      </div>
    </div>
  );
}
